<template>
  <el-form
    label-position="top"
    :model="form"
    :rules="rules"
    ref="form"
    class="text-left"
  >
    <el-row :gutter="30">
      <el-col :span="24" :sm="4">
        <el-form-item label="ลำดับ" prop="number">
          <el-input v-model="form.number"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="8">
        <el-form-item label="ชื่อวิชา" prop="subjectName">
          <el-input v-model="form.subjectName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="ชื่ออาจารย์ผู้สอนวิชา" prop="instructor">
          <el-select v-model="form.instructor" placeholder="" class="width-100">
            <el-option
              v-for="item in instructorsList"
              :key="item._id"
              :label="`${item.nameTH} ${item.surnameTH}`"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12" class="range-open">
        <el-form-item
          label="ระยะเวลาในการเปิด-ปิดวิชา"
          prop="subjectDistanceDate"
          class="line-unset"
        >
          <el-date-picker
            v-model="form.subjectDistanceDate"
            type="daterange"
            class="width-100 show-in-desktop"
            range-separator="ถึง"
            start-placeholder=""
            end-placeholder=""
            format="d MMMM yyyy"
            :picker-options="{
              disabledDate(time) {
                return (
                  time.getTime() < new Date(openCourse).getTime() ||
                  time.getTime() > new Date(closeCourse).getTime()
                );
              },
            }"
          >
          </el-date-picker>
          <div class="flex-display js-between show-in-desktop">
            <span class="color-gray line-initial text-font-12"
              >เวลา 0.00 น.</span
            >
            <span class="color-gray line-initial text-font-12"
              >เวลา 23.59 น.</span
            >
          </div>

          <el-date-picker
            v-model="form.subjectDistanceDate[0]"
            type="date"
            format="d MMMM yyyy"
            class="show-in-mobile width-100"
            :picker-options="{
              disabledDate(time) {
                return (
                  time.getTime() >
                    new Date(form.subjectDistanceDate[1]).getTime() ||
                  time.getTime() < new Date(openCourse).getTime() ||
                  time.getTime() > new Date(closeCourse).getTime()
                );
              },
            }"
          >
          </el-date-picker>
          <span class="color-gray line-initial text-font-12 show-in-mobile"
            >เวลา 0.00 น.</span
          >

          <el-date-picker
            v-model="form.subjectDistanceDate[1]"
            type="date"
            format="d MMMM yyyy"
            class="show-in-mobile mg-t-4 width-100"
            :picker-options="{
              disabledDate(time) {
                return (
                  time.getTime() <
                    new Date(form.subjectDistanceDate[0]).getTime() ||
                  time.getTime() < new Date(openCourse).getTime() ||
                  time.getTime() > new Date(closeCourse).getTime()
                );
              },
            }"
          >
          </el-date-picker>
          <span class="color-gray line-initial text-font-12 show-in-mobile"
            >เวลา 23.59 น.</span
          >
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12" class="set-timeLearn">
        <el-form-item label="เวลาเรียนทั้งหมด" prop="timeLearn">
          <el-input
            v-model="form.timeLearn.hour"
            class="input-time-learn"
          ></el-input>
          <span class="mg-l-4">ชั่วโมง</span>
          <el-input
            v-model="form.timeLearn.min"
            class="mg-l-2 input-time-learn"
          ></el-input>
          <span class="mg-l-4">นาที</span>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="คำอธิบายวิชา">
          <yimo-vue-editor
            v-model="form.courseDescription"
            @input="clearText(form.courseDescription)"
          ></yimo-vue-editor>
        </el-form-item>
      </el-col>

      <el-col :span="24" :sm="12">
        <el-form-item
          label="แนบไฟล์เสียงประกอบวิชา (รองรับไฟล์ .ogg .wav .mp3 .mp4 .m3u .aif .mid ขนาดไม่เกิน 200 MB)"
          prop="courseAudioFile"
        >
          <div v-for="(item, index) in form.courseAudioFile" :key="index">
            <el-upload
              v-if="item.name == ''"
              class="upload-input-text"
              :class="{ 'pd-t-4': index > 0 }"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="(file) => uploadCourseAudioFile(file, index)"
            >
              <template slot="trigger">
                <div class="flex-display ai-center">
                  <el-input v-model="item.name" class=""></el-input>
                  <el-button type="primary" class="light mg-l-4"
                    >แนบไฟล์</el-button
                  >
                </div>
              </template>
            </el-upload>

            <span v-else  class="text-font-12 pd-l-5 mg-y-less"
              ><a :href="typeof item.default != 'undefined'?`${urlCouse}${$route.query.courseId}/${item.file}`:'#'" target="_blank" :class="{'pointer-events-none':typeof item.default === 'undefined'}" class="color-primary-light text-underline">{{
                typeof item.name != "undefined" ? item.name : item.default
              }}</a>
              <i
                @click="delCourseAudioFile(index)"
                class="fas fa-times-circle color-gray-lighter pd-l-5 cursor-pointer"
              ></i
            ></span>
          </div>

          <a @click="addCourseAudioFile" class="color-primary-light"
            >+ เพิ่มไฟล์เสียงประกอบวิชา</a
          >
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item
          label="แนบไฟล์เอกสารประกอบวิชา (รองรับไฟล์ .jpg, .jpeg, .png, doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx  ขนาดไม่เกิน 25 MB )"
          prop="courseDocumentFile"
        >
          <div v-for="(item, index) in form.courseDocumentFile" :key="index">
            <el-upload
              v-if="item.name == ''"
              class="upload-input-text"
              :class="{ 'pd-t-4': index > 0 }"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="(file) => uploadCourseDocumentFile(file, index)"
            >
              <template slot="trigger">
                <div class="flex-display ai-center">
                  <el-input v-model="item.name" class=""></el-input>
                  <el-button type="primary" class="light mg-l-4"
                    >แนบไฟล์</el-button
                  >
                </div>
              </template>
            </el-upload>

            <span v-else class="text-font-12 pd-l-5 mg-y-less"
              ><a :href="typeof item.default != 'undefined'?`${urlCouse}${$route.query.courseId}/${item.file}`:'#'" target="_blank" :class="{'pointer-events-none':typeof item.default === 'undefined'}"  class="color-primary-light text-underline">{{
                typeof item.name != "undefined" ? item.name : item.default
              }}</a>
              <i
                @click="delCourseDocumentFile(index)"
                class="fas fa-times-circle color-gray-lighter pd-l-5 cursor-pointer"
              ></i
            ></span>
          </div>

          <a @click="addCourseDocumentFile" class="color-primary-light"
            >+ เพิ่มไฟล์เอกสารประกอบวิชา</a
          >
        </el-form-item>
      </el-col>
    </el-row>

    <div class="text-center pd-y-3">
      <el-button
        v-if="type == 'add'"
        @click="createSubject"
        type="primary"
        round
        class="pd-x-1"
        >เพิ่มวิชา</el-button
      >
      <el-button
        v-if="type == 'update'"
        @click="updateSubject"
        type="primary"
        round
        class="pd-x-1"
        >บันทึก</el-button
      >
    </div>
  </el-form>
</template>

<script>
import { isFileVideo, isFileAudio } from "@/service/file";
import { HTTP } from "@/service/axios.js";
import { clearText } from "@/service/editor";

export default {
  props: {
    type: {
      type: String,
      default() {
        return "add";
      },
    },
    subject: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    instructorsList() {
      return this.$store.state.instructorsList;
    },
  },
  data() {
    var validateTimeLearn = (rule, value, callback) => {
      if (value.hour == "" && value.min == "") {
        callback(new Error("กรุณากรอกเวลาเรียนทั้งหมด"));
      } else if (
        isNaN(Number(value.hour)) ||
        isNaN(Number(value.min)) ||
        Number(value.hour) < 0 ||
        Number(value.min) < 0
      ) {
        callback(new Error("กรุณากรอกเวลาเรียนทั้งหมดให้ถูกต้อง"));
      } else {
        callback();
      }
    };
    return {
      form: {
        subjectName: "",
        instructor: "",
        subjectDistanceDate: [],
        courseDescription: "",
        timeLearn: { hour: "", min: "" },
        courseAudioFile: [{ name: "", type: "" }],
        courseDocumentFile: [{ name: "", type: "" }],
        number: "",
        urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE
      },
      rules: {
        subjectName: [
          {
            required: true,
            message: "กรุณากรอกชื่อวิชา",
            trigger: "blur",
          },
        ],
        instructor: [
          {
            required: true,
            message: "กรุณากรอกชื่ออาจารย์ผู้สอน",
            trigger: "blur",
          },
        ],
        subjectDistanceDate: [
          {
            required: true,
            message: "กรุณาเลือกระยะเวลาในการเปิด-ปิดวิชา",
            trigger: ["blur", "change"],
          },
        ],
        timeLearn: [
          {
            required: true,
            message: "กรุณากรอกเวลาเรียนทั้งหมด",
            trigger: "blur",
          },
          { validator: validateTimeLearn, trigger: "blur" },
        ],
        number: [
          {
            required: true,
            message: "กรุณากรอกลำดับวิชา",
            trigger: "blur",
          },
        ],
      },
      courseAudioFileDel: [],
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
      openCourse: "",
      closeCourse: "",
      courseDocumentFileDel: [],
    };
  },
  watch: {
    subject() {
      this.setSubject();
    },
  },
  mounted() {
    this.fetchCouseById();
    this.fetchInstructorsList();
    this.setSubject();
  },
  methods: {
    setSubject() {
      if (this.subject != null) {
        this.form = {
          subjectName: this.subject.name,
          instructor: this.subject.instructor,
          subjectDistanceDate: [
            this.subject.durationTime.open,
            this.subject.durationTime.close,
          ],
          courseDescription: this.subject.description,
          timeLearn: {
            hour: this.subject.totalStudyTime.hours,
            min: this.subject.totalStudyTime.minute,
          },
          courseAudioFile: this.subject.attach,
          courseDocumentFile: this.subject.document,
          number: this.subject.index,
        };
      }
    },
    fetchCouseById() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`course/${this.$route.query.courseId}`).then((res) => {
        if (res.data.success) {
          this.openCourse = res.data.obj.durationTime.open;
          this.closeCourse = res.data.obj.durationTime.close;
        }
      });
    },
    fetchInstructorsList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_INSTRUCTORS_LIST", obj);
    },
    uploadCourseAudioFile(file, index) {
      var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      if (
        !this.isFileVideo(file.raw.type) &&
        !this.isFileAudio(file.raw.type)
      ) {
        this.$message.error("ไม่รองรับไฟล์ที่อัพโหลด");
      } else if (sizeInMB > 200) {
        this.$message.error("ไฟล์ที่อัพโหลดขนาดใหญ่เกินกว่าที่รองรับ");
      } else {
        this.form.courseAudioFile[index].name = file.name;
        this.form.courseAudioFile[index].type = file.raw.type;
        this.form.courseAudioFile[index] = file;
      }
    },
    uploadCourseDocumentFile(file, index) {
      var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      if (!this.isFileDocumnet(file.name)) {
        this.$message.error("ไม่รองรับไฟล์ที่อัพโหลด");
      } else if (sizeInMB > 25) {
        this.$message.error("ไฟล์ที่อัพโหลดขนาดใหญ่เกินกว่าที่รองรับ");
      } else {
        this.form.courseDocumentFile[index].name = file.name;
        this.form.courseDocumentFile[index].type = file.raw.type;
        this.form.courseDocumentFile[index] = file;
      }
    },
    addCourseAudioFile() {
      this.form.courseAudioFile.push({ name: "", type: "" });
    },
    delCourseAudioFile(index) {
      if (typeof this.form.courseAudioFile[index].name == "undefined") {
        this.courseAudioFileDel.push(this.form.courseAudioFile[index].file);
      }
      this.form.courseAudioFile.splice(index, 1);
    },
    addCourseDocumentFile() {
      this.form.courseDocumentFile.push({ name: "", type: "" });
    },
    delCourseDocumentFile(index) {
      if (typeof this.form.courseDocumentFile[index].name == "undefined") {
        this.courseDocumentFileDel.push(
          this.form.courseDocumentFile[index].file
        );
      }
      this.form.courseDocumentFile.splice(index, 1);
    },
    createSubject() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("createSubject", this.form);
        }
      });
    },
    updateSubject() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let obj = {
            courseAudioFileDel: this.courseAudioFileDel,
            courseDocumentFileDel: this.courseDocumentFileDel,
          };
          this.$emit("updateSubject", this.form, obj);
        }
      });
    },
  },
};
</script>

<style scoped>
.input-time-learn {
  width: 130px;
}

.image-preview-course {
  width: 370px;
  height: 200px;

  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  border-radius: 5px;
  position: relative;
}
.icon-preview-image {
  position: absolute;
  right: -4px;
  top: -4px;
  color: #c4c4c4;
  cursor: pointer;
  background: #fff;
  border-radius: 20px;
}
.show-preview {
  height: 230px;
}
</style>
